import { Navigate, Outlet } from "react-router-dom";
import { getRoutes } from "@/utils/helpers";
import { useUser } from "@/context/user";
import storage from "@/utils/storage";

const ProtectedRoute = () => {
  const isAuthenticated = useUser((state) => state.isAuthenticated);
  const vid = storage.getItem("vid");

  const routes = getRoutes();

  return isAuthenticated || vid ? <Outlet /> : <Navigate to={routes.signIn} replace />;
};
export default ProtectedRoute;
